enum ResourceType {
  CABIN = 'CABIN',
  CONSULTANT = 'CONSULTANT',
  CUSTOMER_SUPPORT = 'CUSTOMER_SUPPORT',
  FITTER = 'FITTER',
  FITTER_INTERNAL = 'FITTER_INTERNAL',
  VIDEO_CARE_CALL_SPECIALIST = 'VIDEO_CARE_CALL_SPECIALIST',
}

export { ResourceType }
